import { mapGetters } from 'vuex'

const moment = require('moment')
require('moment/locale/pt-br')

export default {
	computed: {
		...mapGetters({
			user: 'auth/getUser',
			npsConfigStorage: 'NPS/getNPSConfig',
		}),

		// Retorna a URI da página
		originURL() {
			return window.location.href
		},

		// Retorna a identidade do usuário (instance + user_id)
		userIdentity() {
			if (!this.user) return undefined

			return this.user.identity
		},

		// Retorna o nome do usuário
		userName() {
			if (!this.user) return undefined

			return this.user.first_name
		},

		// Retorna o email do usuário
		userEmail() {
			if (!this.user) return undefined

			return this.user.email
		},

		// Retorna o celular do usuário
		userMobile() {
			if (!this.user) return undefined

			return this.user.mobile
		},

		// Retorna a foto do usuário
		userAvatar() {
			if (!this.user) return undefined

			return this.user.photo
		},

		// Retorna o grupo do usuário
		// Faz verificação se é um grupo dinâmico
		userGroup() {
			if (!this.user) return undefined

			if (this.user.isDynamicGroup) return 'dynamic'

			return this.user.user_group
		},

		// Retorna o sexo do usuário
		userSex() {
			if (!this.user) return undefined

			return this.user.sex
		},

		// Retorna a mensagem adequado baseada na view ativa
		properMessage() {
			if (!this.npsConfig) return undefined

			if (this.activeViewStage.tag == 'select-rate') return this.npsConfig.nps_question

			if (this.activeViewStage.tag == 'send-message-question')
				return this.npsConfig.nps_comments_question

			if (this.activeViewStage.tag == 'send-message') return 'Digite o seu comentário:'

			if (this.activeViewStage.tag == 'finished') return this.npsConfig.nps_thank_msg

			return undefined
		},

		// Verifica se a possibilidade de adicionar comentários está habilitada.
		commentsActive() {
			if (!this.npsConfig) return undefined

			return this.npsConfig.nps_comments ? true : false
		},

		// Retorna a quantidade mínima de caraceteres para o comentário.
		commentMinSize() {
			if (!this.npsConfig) return undefined

			return this.npsConfig.nps_comments_min_size
		},

		// Verifica se nps_active e nps_show_to_user são true, se algum deles for false, não é permitido mostrar o app.
		// Quando o usuário enviar a nota, a nps_show_to_user é definida para false automaticamente.
		isFullActive() {
			if (!this.npsConfig) return undefined

			return this.npsConfig.nps_active && this.npsConfig.nps_show_to_user ? true : false
		},

		// Retorna a diferencia de nps_active_hour_end e nps_active_hour_start
		timeDifference() {
			if (!this.npsConfig) return undefined

			const start = moment(this.npsConfig.nps_active_hour_start, 'HH:mm')
			const end = moment(this.npsConfig.nps_active_hour_end, 'HH:mm')

			return end.diff(start, 'hours')
		},

		// Verifica se a hora atual está dentro dos limites definidos nas variáveis nps_active_hour_start e nps_active_hour_end,
		// por exemplo: se nps_active_hour_start for: 09:00 e nps_active_hour_end: 14:00, o app só será visível das 9 da manhã até 2 da tarde.
		withinDeadline() {
			if (!this.npsConfig) return undefined

			const now = moment(new Date())
			const start = moment(this.npsConfig.nps_active_hour_start, 'HH:mm')
			const difference = now.diff(start, 'hours')

			return difference >= 0 && difference <= this.timeDifference ? true : false
		},

		// Verifica se o app foi fechado pelo usuário, se ele tiver sido fechado, não é permitido mostrar o app.
		isClosed() {
			if (!this.npsConfig) return undefined

			return this.npsConfig.nps_closed || this.forceClose ? true : false
		},

		// Verifica se o app foi fechado permanentemente, o app é considerado fechado permanentemente quando o usuário fechou o app
		// e a variável nps_force_reply é false.
		isClosedPermanently() {
			if (!this.npsConfig) return undefined

			return this.isClosed && !this.npsConfig.nps_force_reply ? true : false
		},

		// Retorna se é permitido que o app seja mostrado ao usuário.

		// ** A primeira regra é verificar se nps_active e nps_show_to_user são true, se algum deles for false, não é permitido mostrar o app.
		// Quando o usuário enviar a nota, a nps_show_to_user é definida para false automaticamente. (this.isFullActive)

		// ** A segunda regra é verificar se a hora atual está dentro dos limites definidos nas variáveis nps_active_hour_start e nps_active_hour_end,
		// por exemplo: se nps_active_hour_start for: 09:00 e nps_active_hour_end: 14:00, o app só será visível das 9 da manhã até 2 da tarde. (this.withinDeadline)

		// ** A terceira regra é verificar se o app foi fechado pelo usuário, se ele tiver sido fechado, não é permitido mostrar o app. (this.isClosed)

		// ** A quarta regra é verificar se o app foi fechado permanentemente, o app é considerado fechado permanentemente quando o usuário fechou o app
		// e a variável nps_force_reply é false. (this.isClosedPermanently)
		isAllowed() {
			if (!this.npsConfig) return undefined

			return this.isFullActive &&
				this.withinDeadline &&
				!this.isClosed &&
				!this.isClosedPermanently
				? true
				: false
		},
	},
}
